import {
  GET_IMAGE_FOLDERS_URL,
  CREATE_IMAGE_FOLDER_URL,
  UPDATE_IMAGE_FOLDER_URL,
  DELETE_IMAGE_FOLDER_URL,
  GET_IMAGE_FOLDER_DETAILS_URL,
  UPLOAD_IMAGE_URL,
  DELETE_IMAGE_URL,
} from "../apiurls/apiurls";
import Cookies from "js-cookie";

const getAuthToken = () => {
  return Cookies.get("admin_token") || Cookies.get("institution_token");
};

const getHeaders = (includeContentType = true) => {
  const headers = {};
  if (includeContentType) {
    headers["Content-Type"] = "application/json";
  }
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getImageFolders = async () => {
  try {
    const response = await fetch(GET_IMAGE_FOLDERS_URL, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching image folders:", error);
    throw error;
  }
};

export const createImageFolder = async (folderData) => {
  try {
    const response = await fetch(CREATE_IMAGE_FOLDER_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(folderData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating image folder:", error);
    throw error;
  }
};

export const updateImageFolder = async (folderId, folderData) => {
  try {
    const response = await fetch(`${UPDATE_IMAGE_FOLDER_URL}?id=${folderId}`, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(folderData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating image folder:", error);
    throw error;
  }
};

export const deleteImageFolder = async (folderId) => {
  try {
    const response = await fetch(`${DELETE_IMAGE_FOLDER_URL}?id=${folderId}`, {
      method: "DELETE",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting image folder:", error);
    throw error;
  }
};

export const getImageFolderDetails = async (folderId) => {
  try {
    const response = await fetch(
      `${GET_IMAGE_FOLDER_DETAILS_URL}?id=${folderId}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching image folder details:", error);
    throw error;
  }
};

export const uploadImage = async (folderId, formData) => {
  try {
    const response = await fetch(`${UPLOAD_IMAGE_URL}?id=${folderId}`, {
      method: "POST",
      headers: getHeaders(false),
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

export const deleteImage = async (folderId, imageId) => {
  try {
    const response = await fetch(
      `${DELETE_IMAGE_URL}?id=${folderId}&image_id=${imageId}`,
      {
        method: "POST",
        headers: getHeaders(),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting image:", error);
    throw error;
  }
};
